var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.874 8.45005C16.2468 8.45005 9.25845 15.409 9.25845 24.0001C9.25845 32.5911 16.2468 39.55 24.874 39.55C33.5013 39.55 40.4896 32.5911 40.4896 24.0001C40.4896 15.409 33.5013 8.45005 24.874 8.45005ZM7.85254 24.0001C7.85254 14.6358 15.4703 7.05005 24.874 7.05005C34.2778 7.05005 41.8955 14.6358 41.8955 24.0001C41.8955 33.3643 34.2778 40.95 24.874 40.95C15.4703 40.95 7.85254 33.3643 7.85254 24.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8538 18.0053C19.1284 17.732 19.5734 17.732 19.848 18.0053L30.8944 29.0053C31.1689 29.2787 31.1689 29.7219 30.8944 29.9953C30.6198 30.2686 30.1748 30.2686 29.9002 29.9953L18.8538 18.9953C18.5793 18.7219 18.5793 18.2787 18.8538 18.0053Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8944 18.0053C31.1689 18.2787 31.1689 18.7219 30.8944 18.9953L19.848 29.9953C19.5734 30.2686 19.1284 30.2686 18.8538 29.9953C18.5793 29.7219 18.5793 29.2787 18.8538 29.0053L29.9002 18.0053C30.1748 17.732 30.6198 17.732 30.8944 18.0053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0a08cd4e4de76edadd55c84b2ac22c8d.svg";
export { ForwardRef as ReactComponent };